// extracted by mini-css-extract-plugin
export var SpotlightItem = "SpotlightItem-module--SpotlightItem--KIq8l";
export var SpotlightItem_action = "SpotlightItem-module--SpotlightItem_action--nwdtr";
export var SpotlightItem_desc = "SpotlightItem-module--SpotlightItem_desc--fMmdG";
export var SpotlightItem_media = "SpotlightItem-module--SpotlightItem_media--MqgJ5";
export var SpotlightItem_text = "SpotlightItem-module--SpotlightItem_text--laims";
export var SpotlightItem_title = "SpotlightItem-module--SpotlightItem_title--0AV2z";
export var container = "SpotlightItem-module--container--V-GDH";
export var gatsbyImageWrapperConstrained = "SpotlightItem-module--gatsby-image-wrapper-constrained--D8hQU";
export var gridSpan1010 = "SpotlightItem-module--grid-span-10-10--H3V9J";
export var gridSpan1011 = "SpotlightItem-module--grid-span-10-11--UuttA";
export var gridSpan102 = "SpotlightItem-module--grid-span-10-2--lKGE1";
export var gridSpan103 = "SpotlightItem-module--grid-span-10-3--ri1Uv";
export var gridSpan104 = "SpotlightItem-module--grid-span-10-4--38eH0";
export var gridSpan105 = "SpotlightItem-module--grid-span-10-5--XrInM";
export var gridSpan106 = "SpotlightItem-module--grid-span-10-6--xQSQX";
export var gridSpan107 = "SpotlightItem-module--grid-span-10-7--E9ifw";
export var gridSpan108 = "SpotlightItem-module--grid-span-10-8--m6os+";
export var gridSpan109 = "SpotlightItem-module--grid-span-10-9--R4PF6";
export var gridSpan110 = "SpotlightItem-module--grid-span-1-10--c5bhW";
export var gridSpan111 = "SpotlightItem-module--grid-span-1-11--jAnj4";
export var gridSpan1110 = "SpotlightItem-module--grid-span-11-10--EIvIf";
export var gridSpan1111 = "SpotlightItem-module--grid-span-11-11--4ifeq";
export var gridSpan112 = "SpotlightItem-module--grid-span-11-2--ue0Qc";
export var gridSpan113 = "SpotlightItem-module--grid-span-11-3--MKGYO";
export var gridSpan114 = "SpotlightItem-module--grid-span-11-4--sDZDd";
export var gridSpan115 = "SpotlightItem-module--grid-span-11-5--M3cV8";
export var gridSpan116 = "SpotlightItem-module--grid-span-11-6--d9NOh";
export var gridSpan117 = "SpotlightItem-module--grid-span-11-7--OQCB6";
export var gridSpan118 = "SpotlightItem-module--grid-span-11-8--S58tp";
export var gridSpan119 = "SpotlightItem-module--grid-span-11-9--ZgNVF";
export var gridSpan12 = "SpotlightItem-module--grid-span-1-2--GAxrL";
export var gridSpan1210 = "SpotlightItem-module--grid-span-12-10--xp-Ku";
export var gridSpan1211 = "SpotlightItem-module--grid-span-12-11--fIelT";
export var gridSpan122 = "SpotlightItem-module--grid-span-12-2--CbbQW";
export var gridSpan123 = "SpotlightItem-module--grid-span-12-3--sP7cT";
export var gridSpan124 = "SpotlightItem-module--grid-span-12-4--IiudE";
export var gridSpan125 = "SpotlightItem-module--grid-span-12-5--d8ocQ";
export var gridSpan126 = "SpotlightItem-module--grid-span-12-6--ZBcve";
export var gridSpan127 = "SpotlightItem-module--grid-span-12-7--AKxl6";
export var gridSpan128 = "SpotlightItem-module--grid-span-12-8--L7d8Z";
export var gridSpan129 = "SpotlightItem-module--grid-span-12-9--4Zz7O";
export var gridSpan13 = "SpotlightItem-module--grid-span-1-3--d200i";
export var gridSpan14 = "SpotlightItem-module--grid-span-1-4--alm4e";
export var gridSpan15 = "SpotlightItem-module--grid-span-1-5--MRNGm";
export var gridSpan16 = "SpotlightItem-module--grid-span-1-6--XBqjh";
export var gridSpan17 = "SpotlightItem-module--grid-span-1-7--bfNvZ";
export var gridSpan18 = "SpotlightItem-module--grid-span-1-8--3Dj3y";
export var gridSpan19 = "SpotlightItem-module--grid-span-1-9--hQNgP";
export var gridSpan210 = "SpotlightItem-module--grid-span-2-10--57JJm";
export var gridSpan211 = "SpotlightItem-module--grid-span-2-11--HPiEy";
export var gridSpan22 = "SpotlightItem-module--grid-span-2-2--nZ0pA";
export var gridSpan23 = "SpotlightItem-module--grid-span-2-3---df04";
export var gridSpan24 = "SpotlightItem-module--grid-span-2-4--3N5vI";
export var gridSpan25 = "SpotlightItem-module--grid-span-2-5--WdVYJ";
export var gridSpan26 = "SpotlightItem-module--grid-span-2-6--TCj9H";
export var gridSpan27 = "SpotlightItem-module--grid-span-2-7--WvxcY";
export var gridSpan28 = "SpotlightItem-module--grid-span-2-8--AID7s";
export var gridSpan29 = "SpotlightItem-module--grid-span-2-9--RRzyX";
export var gridSpan310 = "SpotlightItem-module--grid-span-3-10--sLYPH";
export var gridSpan311 = "SpotlightItem-module--grid-span-3-11--svRwR";
export var gridSpan32 = "SpotlightItem-module--grid-span-3-2--b6mna";
export var gridSpan33 = "SpotlightItem-module--grid-span-3-3--9U2Cx";
export var gridSpan34 = "SpotlightItem-module--grid-span-3-4--bI+rI";
export var gridSpan35 = "SpotlightItem-module--grid-span-3-5--eB1jn";
export var gridSpan36 = "SpotlightItem-module--grid-span-3-6--pdtWQ";
export var gridSpan37 = "SpotlightItem-module--grid-span-3-7--STHTy";
export var gridSpan38 = "SpotlightItem-module--grid-span-3-8--CrkpJ";
export var gridSpan39 = "SpotlightItem-module--grid-span-3-9--KoLr4";
export var gridSpan410 = "SpotlightItem-module--grid-span-4-10--NVVRd";
export var gridSpan411 = "SpotlightItem-module--grid-span-4-11--ECAyN";
export var gridSpan42 = "SpotlightItem-module--grid-span-4-2--QToRK";
export var gridSpan43 = "SpotlightItem-module--grid-span-4-3--OiU3S";
export var gridSpan44 = "SpotlightItem-module--grid-span-4-4--0fx+C";
export var gridSpan45 = "SpotlightItem-module--grid-span-4-5--HKcjv";
export var gridSpan46 = "SpotlightItem-module--grid-span-4-6--tXn8E";
export var gridSpan47 = "SpotlightItem-module--grid-span-4-7--1PVF+";
export var gridSpan48 = "SpotlightItem-module--grid-span-4-8--Bi4F5";
export var gridSpan49 = "SpotlightItem-module--grid-span-4-9--mG83B";
export var gridSpan510 = "SpotlightItem-module--grid-span-5-10--nDadf";
export var gridSpan511 = "SpotlightItem-module--grid-span-5-11--wAqjT";
export var gridSpan52 = "SpotlightItem-module--grid-span-5-2--O6bWQ";
export var gridSpan53 = "SpotlightItem-module--grid-span-5-3--tSBnM";
export var gridSpan54 = "SpotlightItem-module--grid-span-5-4--ziMLD";
export var gridSpan55 = "SpotlightItem-module--grid-span-5-5--78j6h";
export var gridSpan56 = "SpotlightItem-module--grid-span-5-6--oR8BJ";
export var gridSpan57 = "SpotlightItem-module--grid-span-5-7--caBW7";
export var gridSpan58 = "SpotlightItem-module--grid-span-5-8--1Is4A";
export var gridSpan59 = "SpotlightItem-module--grid-span-5-9--nCQnT";
export var gridSpan610 = "SpotlightItem-module--grid-span-6-10--93dGM";
export var gridSpan611 = "SpotlightItem-module--grid-span-6-11--YUNWU";
export var gridSpan62 = "SpotlightItem-module--grid-span-6-2--Zu88e";
export var gridSpan63 = "SpotlightItem-module--grid-span-6-3--cimOd";
export var gridSpan64 = "SpotlightItem-module--grid-span-6-4--UT9z+";
export var gridSpan65 = "SpotlightItem-module--grid-span-6-5--UsT1J";
export var gridSpan66 = "SpotlightItem-module--grid-span-6-6--ImOpO";
export var gridSpan67 = "SpotlightItem-module--grid-span-6-7--axpZG";
export var gridSpan68 = "SpotlightItem-module--grid-span-6-8--gF5ES";
export var gridSpan69 = "SpotlightItem-module--grid-span-6-9--FXG51";
export var gridSpan710 = "SpotlightItem-module--grid-span-7-10--JQ+rI";
export var gridSpan711 = "SpotlightItem-module--grid-span-7-11--t5yE9";
export var gridSpan72 = "SpotlightItem-module--grid-span-7-2--tvjNr";
export var gridSpan73 = "SpotlightItem-module--grid-span-7-3--OqUkn";
export var gridSpan74 = "SpotlightItem-module--grid-span-7-4--V6sQo";
export var gridSpan75 = "SpotlightItem-module--grid-span-7-5--aWbjm";
export var gridSpan76 = "SpotlightItem-module--grid-span-7-6--Nc+Pe";
export var gridSpan77 = "SpotlightItem-module--grid-span-7-7--hJl2a";
export var gridSpan78 = "SpotlightItem-module--grid-span-7-8--fJbRX";
export var gridSpan79 = "SpotlightItem-module--grid-span-7-9--QIocU";
export var gridSpan810 = "SpotlightItem-module--grid-span-8-10--TbM88";
export var gridSpan811 = "SpotlightItem-module--grid-span-8-11--1JKS3";
export var gridSpan82 = "SpotlightItem-module--grid-span-8-2--Aoq3U";
export var gridSpan83 = "SpotlightItem-module--grid-span-8-3--4MPBz";
export var gridSpan84 = "SpotlightItem-module--grid-span-8-4--z-fl9";
export var gridSpan85 = "SpotlightItem-module--grid-span-8-5--v1zvA";
export var gridSpan86 = "SpotlightItem-module--grid-span-8-6--Nj+uX";
export var gridSpan87 = "SpotlightItem-module--grid-span-8-7--+9xo8";
export var gridSpan88 = "SpotlightItem-module--grid-span-8-8---vmk8";
export var gridSpan89 = "SpotlightItem-module--grid-span-8-9--QNKfw";
export var gridSpan910 = "SpotlightItem-module--grid-span-9-10--FHEoY";
export var gridSpan911 = "SpotlightItem-module--grid-span-9-11--xxdmK";
export var gridSpan92 = "SpotlightItem-module--grid-span-9-2--3vIoq";
export var gridSpan93 = "SpotlightItem-module--grid-span-9-3--IhV7H";
export var gridSpan94 = "SpotlightItem-module--grid-span-9-4--zNdMp";
export var gridSpan95 = "SpotlightItem-module--grid-span-9-5--rrFMK";
export var gridSpan96 = "SpotlightItem-module--grid-span-9-6--fL-Qj";
export var gridSpan97 = "SpotlightItem-module--grid-span-9-7--GGEF4";
export var gridSpan98 = "SpotlightItem-module--grid-span-9-8--bUJlt";
export var gridSpan99 = "SpotlightItem-module--grid-span-9-9--yjFFe";
export var textBreak = "SpotlightItem-module--text-break--u0tRP";